export default class Processors {
  private outputFilename: string;
  private filenameChanged: boolean;
  private notes: string;
  private type: string;

  constructor(
    outputFilename: string,
    filenameChanged: boolean,
    notes: string = "",
    type: string = "passThroughProcessor"
  ) {
    this.outputFilename = outputFilename;
    this.filenameChanged = filenameChanged;
    this.notes = notes;
    this.type = type;
  }
}
